const theme = {
  fonts: {
  	avant: "'itc-avant-garde-gothic-pro', Helvetica, Arial, sans-serif",
  	p: "Georgia, Times New Roman, serif",
  	helvetica: "'Helvetica Neue', Helvetica, Arial, sans-serif",
  }
}
export default theme
